// @flow
import React, { Component } from 'react'
import { Card, Spin } from 'antd';
import { StyledMember, StyledContent } from './style'
import ApiService from '../../actions/apiService';
import ReactMarkdown from 'react-markdown'

class PrivacyPolicy extends Component {
  
  state = {
    content: 'Privacy Policy',
    isLoading: true,
  }
  
  async componentWillMount() {
    const response = await ApiService.getMethod('/pages/privacypolicy');
    if (response) {
      this.setState({
        content: response,
      })
    }
    this.setState({
      isLoading: false,
    });
  }
  
  render() {
    
    return (
      <StyledContent>
        <StyledMember>
          <Card title="Privacy Policy" bordered={false}>
            {
              this.state.isLoading ? <Spin/> : <ReactMarkdown escapeHtml={false} source={this.state.content} />
            }
          </Card>
        </StyledMember>
      </StyledContent>
    )
  }
}

export default PrivacyPolicy;



// WEBPACK FOOTER //
// ./src/components/static/PrivacyPolicy.js